<template>
  <v-btn
    v-if="currentUser.permissions.add_to_collections === true"
    :disabled="itemsCount <= 0"
    right
    color="primary"
    class="mr-2 mb-1"
    @click="removeFromCollection"
  >
    <span class="d-none d-md-flex">Remove selected from collection</span>
    <v-icon right>mdi-minus</v-icon>
  </v-btn>
</template>

<script>
import { mapGetters } from "vuex";
import store from "@/store/";
import { SELECTED_RESET } from "@/store/actions.type";
import ApiService from "@/common/api.service";
import toast from "@/services/toast";

export default {
  name: "RemoveFromCollection",
  props: {
    collectionId: "",
  },
  data: () => ({}),
  computed: {
    itemsCount() {
      // Number of selected images.
      return this.selectedImagesIds.length;
    },
    ...mapGetters([
      "selectedImagesIds",
      "activeExpClient",
      "collection",
      "imageSearchResult",
      "currentUser",
    ]),
  },
  methods: {
    removeFromCollection() {
      this.msg = ApiService.delete("collection-photos", {
        client_id: this.activeExpClient.id,
        collection_id: this.collectionId,
        photo_ids: this.selectedImagesIds,
      })
        .then((resp) => {
          toast.success(resp.data.message);
          let results = [];
          results = this.imageSearchResult.data.filter(
            ({ id }) => !this.selectedImagesIds.includes(id)
          );
          this.imageSearchResult.data = results;
          store.dispatch(SELECTED_RESET);
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>

